
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-upscaler",
      function () {
        return require("private-next-pages/image-upscaler/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-upscaler"])
      });
    }
  